import router from '@/router'
import axios from 'axios'

export default {
  GET_REPORTS({ commit }) {
    commit('SET_LOADING', true)
    axios({
      method: 'GET',
      url: '/api/report/GetReportsForDelivery'
    })
      .then(response => {
        commit('GET_REPORTS_SUCCESS', response.data)
        commit('SET_LOADING', false)
      })
      .catch(error => {
        commit('GET_REPORTS_ERROR', error.response.data)
        commit('SET_LOADING', false)
      })
  },
  GET_REPORT_TEMPLATE({ commit }, { name, inn, okpo, reportId }) {
    commit('SET_PRELOADER', true)
    axios({
      method: 'GET',
      url: `/api/report/GetReportTemplate/${name}`,
      params: { inn, okpo, reportId }
    })
      .then(response => {
        commit('GET_REPORT_TEMPLATE_SUCCESS', response.data)
        commit('SAVE_RESPONDENT_PARAMS', {
          inn: response.data.page1.organizationInn,
          okpo: response.data.page1.okpo
        })
        commit('SET_PRELOADER', false)
      })
      .catch(error => {
        commit('GET_REPORT_TEMPLATE_ERROR', error.response.data)
        commit('SET_PRELOADER', false)
      })
  },
  CALCULATE_REPORT({ commit }, data) {
    commit('CALCULATE_REPORT_LOADING', true)
    commit('SET_DISABLED_SEND_REPORT_BTN', true)
    axios({
      method: 'POST',
      url: `/api/report/Calculate/${data.id}`,
      data: data.report
    })
      .then(response => {
        if (!response.data.success) {
          commit('SET_CALCULATED_REPORT_SUCCESS', response.data)
          commit('SET_VALIDATION_ERRORS', response.data.validationErrors)
          commit('CALCULATE_REPORT_LOADING', false)
        }
        if (response.data.success) {
          commit('SET_CALCULATED_REPORT_SUCCESS', response.data)
          commit('SET_CONTROLS', response.data.permissibleControls)
          commit('CALCULATE_REPORT_LOADING', false)
        }
      })
      .catch(error => {
        commit('CALCULATE_REPORT_LOADING', false)
        commit('CALCULATE_REPORT_ERROR', error.response.data.message)
      })
  },
  SUBMIT_REPORT({ commit, state, dispatch }, { reportId, reportKey, isCurator, inn, okpo, controls }) {
    const data = state.reportTemplate
    commit('LOADING_SEND_REPORT', true)
    return axios({
      method: 'POST',
      url: `/api/report/SaveReport/${reportKey}/${reportId}`,
      data: { data, controls },
      params: { respondentInn: inn, okpo }
    })
      .then(response => {
        isCurator ? router.push({ path: '/main/curator-archive' }) : router.push({ path: '/main/archive' })
        commit('CLEAR_REPORT_TEMPLATE')
        commit('CLEAR_CONTROLS')
      })
      .catch(error => {
        commit('SUBMIT_REPORT_ERROR', error.response.data.message)
        dispatch('NOTIFICATION', { open: true, color: 'red', text: error.response.data.message })
      })
      .finally(() => {
        commit('LOADING_SEND_REPORT', false)
        commit('SET_DISABLED_SEND_REPORT_BTN', true)
      })
  },
  DRAFT_REPORT({ commit, state, dispatch }, { id, statReportId, report, inn, okpo }) {
    return axios({
      method: 'POST',
      url: `/api/report/SaveReport/${id}/${statReportId}/true`,
      data: { data: report },
      params: { respondentInn: inn, okpo }
    })
      .then(response => {
        if (response.data) router.push({ path: '/main/draft' })
      })
      .catch(error => {
        commit('DRAFT_REPORT_ERROR', error.response.data.message)
        dispatch('NOTIFICATION', { open: true, color: 'red', text: error.response.data.message })
      })
  },
  GET_REPORT_LIST({ commit }) {
    axios({
      method: 'GET',
      url: '/api/statistic/GetReportList'
    })
      .then(response => {
        commit('GET_REPORT_LIST_SUCCESS', response.data)
      })
      .catch(error => {
        commit('GET_REPORT_LIST_ERROR', error.response.data.message)
      })
  },
  GET_STATISTIC({ commit }, { reportKey, startDate, expirationDate }) {
    commit('GET_STATISTIC_LOADING', true)
    axios({
      method: 'GET',
      url: `/api/statistic/${reportKey}`,
      params: { startDate, expirationDate }
    })
      .then(response => {
        commit('GET_STATISTIC_SUCCESS', response.data)
        commit('GET_STATISTIC_LOADING', false)
      })
      .catch(error => {
        commit('GET_STATISTIC_ERROR', error.response.data.message)
        commit('GET_STATISTIC_LOADING', false)
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/reporting/actions.js